export default __webpack_public_path__ + "static/media/kamrambek.a83cc483.jpg";